import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Contact from '../pages/contact';
import Layout from '../components/layout';
import Services from '../components/services';
import Stats from '../components/stats';

const Home = () => (
  <>
    <Services />
    <Stats />
  </>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: 'contact',
        element: <Contact />
      }
    ]
  }
]); 